/* /ess/payslips — own payslips for the last six months (prototype pgEssPayslips / payslipList). */
import { useNavigate } from "react-router-dom";
import { useEmployee, usePayslip, useToday } from "../../data/hooks";
import { useI18n } from "../../i18n";
import { periodLabel } from "../../lib/format";
import { Card, Chip, DualDate, Icon, Loaded, Money, PageHeader, Skeleton } from "../../ui";
import { NoLink } from "./EssHome";
import { PAY_DAY, periodOf, shiftPeriod, useEmployeeId } from "./essLib";

function Row({ empId, period }: { empId: number; period: string }) {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const q = usePayslip(empId, period);
  const go = () => nav("/payslip/" + empId + "/" + period);
  return (
    <tr className="click" onClick={go} onKeyDown={(e) => { if (e.key === "Enter") go(); }} tabIndex={0} data-testid={"slip-" + period}>
      <td className="k1"><b>{periodLabel(period, lang)}</b></td>
      <td className="x" data-l={t("Pay date")}><DualDate date={period + "-" + String(PAY_DAY).padStart(2, "0")} /></td>
      <td className="end k3" data-l={t("Net pay")}>{q.data ? <Money value={q.data.net} /> : q.error ? "—" : <span className="skel" style={{ display: "inline-block", width: 80, height: 14 }} />}</td>
      <td className="k2"><Chip status="Paid" /></td>
      <td className="end hide-md"><Icon name="chevron-right" className="s" /></td>
    </tr>
  );
}

function Body({ empId }: { empId: number }) {
  const { t, name } = useI18n();
  const today = useToday();
  const emp = useEmployee(empId);
  const cur = periodOf(today);
  const periods = [1, 2, 3, 4, 5, 6].map((k) => shiftPeriod(cur, -k));
  return (
    <div className="ess" data-testid="ess-payslips">
      <Loaded q={emp}>{(e) => <PageHeader title={t("Payslips")} sub={name(e) + " · " + e.code} />}</Loaded>
      <Card flush>
        {emp.isLoading ? <div className="card-b"><Skeleton /></div> : (
          <div className="tw">
            <table className="tbl cards" data-testid="payslips-table">
              <thead><tr><th>{t("Month")}</th><th>{t("Pay date")}</th><th className="end">{t("Net pay")}</th><th>{t("Status")}</th><th aria-hidden="true" /></tr></thead>
              <tbody>{periods.map((p) => <Row key={p} empId={empId} period={p} />)}</tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}

export default function EssPayslips() {
  const id = useEmployeeId();
  return id == null ? <NoLink /> : <Body empId={id} />;
}
